<template>
  <v-container>
    <campaign-detail scope="company" />
  </v-container>
</template>

<script>
import CampaignDetail from "@/components/admin/campaign/CampaignDetail.vue";

export default {
  components: { CampaignDetail },
  metaInfo: { title: "Campanha" },
};
</script>
